import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { BreadcrumbService } from './breadcrumb.service';
import { Router, ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { StudentsService } from '../students.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit, OnDestroy {

  private studentIdEncrypted;
  private creboId;
  private destroy$ = new Subject();
  private breadcrumbSubscription: Subscription;
  private isBatch = false;
  
  public items = [];
  constructor(
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    private route: ActivatedRoute,
    private studentService: StudentsService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(data => {
      this.isBatch = data['batch'] != undefined && data['batch'] == "1";
    });
    this.breadcrumbSubscription = this.breadcrumbService.$breadcrumbUpdated.subscribe(data => {
      this.items = data;
    });

    this.route.params
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(params => {
        this.studentIdEncrypted = params['studentIdEncrypted'];
        this.creboId = params['creboId'];
      });
  }

  ngOnDestroy(): void {
    this.breadcrumbSubscription.unsubscribe();
  }

  clickStudentenOverzicht() {
    this.router.navigate(['students', this.studentIdEncrypted, this.creboId, 'crebos'], { queryParamsHandling: 'merge' });
  }
}



// WEBPACK FOOTER //
// ./src/app/breadcrumb/breadcrumb.component.ts